/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface Preset {
  name: string;
  description: string;
  root: number;
  base: number;
  power: number;
  weight: number;
  method: 'full' | 'contracted';
}

export const PRESETS: Preset[] = [
  {
    name: "Pascal's Triangle",
    description: 'Classic binomial coefficients (Root 1, Base 2, Weight 0)',
    root: 1,
    base: 2,
    power: 5,
    weight: 0,
    method: 'contracted',
  },
  {
    name: 'Trinomial Triangle',
    description: 'Expansion of (1+1+1)^n (Root 1, Base 3, Weight 0)',
    root: 1,
    base: 3,
    power: 4,
    weight: 0,
    method: 'contracted',
  },
  {
    name: 'Binary Shifting (Case 4)',
    description: 'Boundary shifting with weight 1 (Root 1, Base 2)',
    root: 1,
    base: 2,
    power: 3,
    weight: 1,
    method: 'full',
  },
];

export interface RowData {
  level: number;
  elements: number[];
  sum: number;
  expectedSum: number;
}
